import classNames from "classnames";

const Section = ({ children, className = "" }) => {
    return <div className={classNames("k-section", className)}>{children}</div>;
};

export default Section;
